import React, { Component } from 'react';
import PropTypes from 'prop-types';

// ours
import { ErrorGeneric } from 'pages';
import { reportError } from 'errorReporting';

class ErrorBoundary extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
            .isRequired,
        history: PropTypes.object.isRequired,
    };

    state = {
        error: false,
        info: '',
        unlisten: null,
    };

    // TODO use getDerivedStateFromError when available
    componentDidCatch(error, info) {
        reportError(
            error.message || 'Error caught in React Error Boundary',
            error,
        );
        this.setState({ error, info });
    }

    componentDidMount() {
        const unlisten = this.props.history.listen(this.handleRouteChange);

        this.setState({ unlisten });
    }

    componentWillUnmount() {
        if (this.state.unlisten) {
            this.state.unlisten();
        }
    }

    handleRouteChange = () => {
        this.setState({ error: false, info: '' });
    };

    render() {
        const { children } = this.props;
        const { error } = this.state;

        if (!error) {
            return children;
        }

        return <ErrorGeneric />;
    }
}

export default ErrorBoundary;
